module.exports = __webpack_public_path__ + "img/hr-red-desert-2.dfd3fb97.png";